import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// HeadlessUI's floating-UI positioning triggers benign ResizeObserver loop
// notifications during combobox/dropdown rendering. Suppress the noise.
const _onerror = window.onerror
window.onerror = (msg, ...args) => {
  if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) return true
  return _onerror ? _onerror(msg, ...args) : false
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
